import { render, staticRenderFns } from "./JournalGrz.vue?vue&type=template&id=0c29cbc4&scoped=true"
import script from "./JournalGrz.vue?vue&type=script&lang=js"
export * from "./JournalGrz.vue?vue&type=script&lang=js"
import style0 from "./JournalGrz.vue?vue&type=style&index=0&id=0c29cbc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c29cbc4",
  null
  
)

export default component.exports